import { NgModule } from '@angular/core';
import { AsteriskDirective } from './asterisk.directive';


@NgModule({
    declarations: [
        AsteriskDirective,
    ],
    exports: [
        AsteriskDirective,
    ],
})
export class AsteriskModule { }